// Generated by `pnpm --filter @corca/data build-libraries`. Do not edit.

/**
 * Every generated library key: the core set the bundle ships, not the default set a document
 * gets, which the API configures.
 */
export const LIBRARY_KEYS = [
  "abstract-algebra",
  "algebra",
  "algebraic-topology",
  "analysis",
  "analysis-of-algorithms",
  "arithmetic",
  "arithmetics",
  "calculus",
  "category-theory",
  "chemistry",
  "combinatorics",
  "complex-analysis",
  "computer-science",
  "constants",
  "differential-geometry",
  "discrete-mathematics",
  "electromagnetism",
  "extended-latin",
  "function-analysis",
  "functional-analysis",
  "functional-operators",
  "game-theory",
  "general",
  "geometry",
  "greek-alphabet",
  "group-theory",
  "letters-and-unicode",
  "linear-algebra",
  "logic",
  "math-variables",
  "mathematical-alphanumeric-symbols",
  "mathematical-analysis",
  "mathematical-logic",
  "mathematical-symbols",
  "number-theory",
  "order-theory",
  "other",
  "physics-variables",
  "quantum-mechanics",
  "set-theory",
  "special-functions",
  "statistics",
  "topology",
  "trigonometry",
  "typography",
  "vector-analysis",
] as const;

export type LibraryKey = (typeof LIBRARY_KEYS)[number];
